// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SupplierSubmission extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  confirmationKey?: string;
  /** Guid */
  entityId!: string;
  /** String */
  errorMessage?: string;
  /** DateTimeOffset */
  submissionTs?: Date;
  /** Guid FK supplier */
  supplierId!: string;
  /** String(200) */
  tableName!: string;
  /** Boolean */
  wasPreviouslySubmitted!: boolean;
  /** FK supplierId */
  supplier!: Supplier;
}

